module.exports = {
      id: "plus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#plus",
      toString: function () {
        return this.url;
      }
    }